import React from "react";
import { Box, Chip } from "@mui/material";
import { RISK_COLORS, TEXT_COLORS } from "../../constants/colors";
import { EUDRBenchmarking, EUDR_DISPLAY_TEXT } from "../../constants/eudr";

const EUDR_RISK_COLOR_MAP = {
  [EUDRBenchmarking.LOW]: RISK_COLORS.LOW,
  [EUDRBenchmarking.STANDARD]: RISK_COLORS.MEDIUM,
  [EUDRBenchmarking.HIGH]: RISK_COLORS.HIGH,
} as const;

interface RiskLabelProps {
  value: EUDRBenchmarking;
}

export default function RiskLabel({ value }: RiskLabelProps) {
  return (
    <Box display="flex" justifyContent="center" alignItems="center">
      <Chip
        label={EUDR_DISPLAY_TEXT[value]}
        sx={{
          backgroundColor: EUDR_RISK_COLOR_MAP[value] || RISK_COLORS.MEDIUM,
          color: value === EUDRBenchmarking.STANDARD ? TEXT_COLORS.PRIMARY : "white",
          fontWeight: "500",
          fontSize: "14px",
          minWidth: "100px",
          height: "32px",
        }}
      />
    </Box>
  );
}
